export const manufacturerMapping = {
 "AC" : 'ACER',
 "AS" : 'ASUS',
 "DE" : 'DELL',
 "DR" : 'DREAMHACK',
 "FU" : 'FUJITSU',
 "HP" : 'HP',
 "HU" : 'HUAWEI',
 "IN" : 'SYSTEM_INTEL',
 "LE" : 'LENOVO',
 "MI" : 'MICROSOFT',
 "MO" : 'MOTOROLA',
 "MS" : 'MSI',
 "RA" : 'RAZER',
 "SA" : 'SAMSUNG',
 "SO" : 'SONY',
 "TO" : 'TOSHIBA',
 "VI" : 'VIZIO',
 "AL" : "ALIENWARE",
 "GA" : "GATEWAY",  
 "LG" : "LG",       
 "VA" : "VAIO"   
}
export const manufacturerNewMapping = {
    "A" : 'ACER',
    "B" : 'ASUS',
    "C" : 'DELL',
    "D" : 'DREAMHACK',
    "E" : 'FUJITSU',
    "F" : 'HP',
    "G" : 'HUAWEI',
    "H" : 'SYSTEM_INTEL',
    "I" : 'LENOVO',
    "J" : 'MICROSOFT',
    "K" : 'MOTOROLA',
    "L" : 'MSI',
    "M" : 'RAZER',
    "N" : 'SAMSUNG',
    "O" : 'SONY',
    "P" : 'TOSHIBA',
    "Q" : 'VIZIO',
    "R" : "ALIENWARE",
    "S" : "GATEWAY",  
    "T" : "LG",       
    "U" : "VAIO"   
   }

export const wifiModels = {
    1 : "KILLER_WIFI_6E_AX1675I",
    2 : "KILLER_WIFI_6E_AX1675S",
    3 : "KILLER_WIFI_6E_AX1675W",
    4 : "KILLER_WIFI_6E_AX1675X",
    5 : "KILLER_WIFI_6E_AX1690",
    6 : "INTEL_WIFI_6_AX101" 
}

export const wifiFamilyValues = {
    "A" : "UNKNOWN",
    "B" : "INTEL_WIFI_6",
    "C" : "INTEL_WIFI_6E",
    "D" : "KILLER_WIFI_6",
    "E" : "KILLER_WIFI_6E",
    "F" : "INTEL_WIFI_7",
    "G" : "KILLER_WIFI_7"
}

export const LanguageDecode = {
    "ar-sa" : "Arabic Saudi Arabia",
    "cs" : "Czech Czech Republic",
    "da" : "Danish Denmark",
    "de" : "German Germany",
    "el" : "Greek Greece",
    "es-mx" : "Spanish Mexico",
    "es" : "Spanish Spain",
    "en-us" : "English US",
    "fi" : "Finnish Finland",
    "fr" : "French France",
    "he" : "Hebrew Israel",
    "hu" : "Hungarian Hungary",
    "id" : "Indonesian Indonesia",
    "is" : "Icelandic Iceland",
    "it" : "Italian Italy",
    "ja" : "Japanese Japan",
    "ko" : "Korean South Korea",
    "nb" : "Norwegian - Bokmål Norway",
    "nl" : "Dutch Netherlands",
    "pl" : "Polish Poland",
    "pt-pt" : "Portuguese Portuga",
    "pt-br" : "Portuguese Brazil",
    "ro" : "Romanian Romania",
    "ru" : "Russian Russia",
    "sk" : "Slovak Slovakia",
    "sv" : "Swedish Sweden",
    "th" : "Thai Thailand",
    "tr" : "Turkish Turkey",
    "uk" : "Ukrainian Ukraine",
    "vi" : "Vietnamese Vietnam",
    "zh-cn" : "Simplified Chinese China",
    "zh-tw" : "Traditional Chinese Taiwan"
}

export const graphicsBadge = {
    "A" : "GIN000",
    "B" : "GIN001",
    "C" : "GIN002",
    "D" : "GIN003",
    "E" : "GIN004",
    "F" : "GIN005",
    "G" : "GNV000",
    "H" : "GIN007",
    "I" : "GIN008",
    "J" : "GIN009",
    "K" : "GIN010",
    "L" : "GIN011",
    "M" : "GIN012",
    "N" : "GIN013",
    "O" : "GUN000",
    "P" : "GAM000",
    "Q" : "ARC001",
    "R" : "A350M",
    "S" : "A370M",
    "T" : "A730M",
    "U" : "A770M",
    "V" : "A310",
    "W" : "A380",
    "X" : "A580",
    "Y" : "A750",
    "Z" : "A770",
    "a" : "A530M",
    "b" : "A550M",
    "c" : "A570M",
    "d" : "A570",
    "e" : "ARC002",
    "f" : "ARC003",
    "g" : "B570",
    "h" : "B580"
}

export const lang = {
    'A' : "ar-sa",
    'B' : "cs",
    'C' : "da",
    'D': 'de',
    'E': 'el',
    'F': 'en-us',
    'G': 'es',
    'H': 'es-mx',
    'I': 'fi',
    'J': 'fr',
    'K': 'he',
    'L': 'hu',
    'M': 'id',
    'N': 'is',
    'O': 'it',
    'P': 'ja',
    'Q': 'ko',
    'R': 'nb',
    'S': 'nl',
    'T': 'pl',
    'U': 'pt-br',
    'V': 'pt',
    'W': 'ro',
    'X': 'ru',
    'Y': 'sk',
    'Z': 'sv',
    'a': 'th',
    'b': 'tr',
    'c': 'uk',
    'd': 'vi',
    'e': 'zh-cn',
    'f': 'zh-tw'
}

export const contentTypeDesc = {
    'A': 'ath',
    'B': 'evo',
    'C': 'NI',
    'D': 'G9',
    'E': 'G10',
    'F': 'G11',
    'G': 'G12',
    'H': 'G13',
    'I': 'G14',
    'J': 'R10',
    'K': 'R11',
    'L': 'R12',
    'M': 'R13',
    'N': 'S10',
    'O': 'S11',
    'P': 'S12',
    'Q': 'S13',
    'R': 'S14',
    'S': 'SNA',
    'T': 'UNKNOWN'
}
export const operatingSystemMapping = {
    'A': 'WIN',
    'B': 'W11',
    'C': 'NONWIN',
    'D': 'W11S',
    'E': 'W11U',
    'F': 'W10S',
    'G': 'W10',
    'H': 'WNA',
    'I': 'UWP',
    'J': 'ANA'
};
 export const displayTypeMapping ={    
    "2880x1800" : "2_8K",
    "3200x2000" : "3_2K",
    "3072x1920" : "3K",
    "3840x2160" : "4K_UHD",
    "5120x2880" : "5K",
    "7680x4320" : "8K_UHD",
    "2048x1080" : "DCI_2K",
    "4096x2160" : "DCI_4K",
    "960x640" : "DVGA",
    "1920x1080" : "FHD",
    "854x480" : "FWVGA",
    "1280x720" : "HD",
    "240x160" : "HQVGA",
    "5120x4096" : "HSXGA",
    "6400x4800" : "HUXGA",
    "480x320" : "HVGA",
    "4096x3072" : "HXGA",
    "640x360" : "NHD",
    "960x540" : "QHD",
    "3200x1800" : "QHD_PLUS",
    "160x120" : "QQVGA",
    "2560x2048" : "QSXGA",
    "3200x2400" : "QUXGA",
    "320x240" : "QVGA",
    "2048x1152" : "QWXGA",
    "2048x1536" : "QXGA",
    "800x600" : "SVGA",
    "1280x1024" : "SXGA",
    "1400x1050" : "SXGA_PLUS",
    "3440x1440" : "UWQHD",
    "1600x1200" : "UXGA",
    "640x480" : "VGA",
    "6400x4896" : "WHSXGA",
    "7680x4800" : "WHUXGA",
    "5120x3200" : "WHXGA",
    "2560x1440" : "WQHD",
    // "3200x2400" : "WQSXGA",
    "3840x2400" : "WQUXGA",
    "400x240" : "WQVGA",
    "2560x1600" : "WQXGA",
    "1024x576" : "WSVGA",
    "1024x600" : "WSVGA",
    "1680x1050" : "WSXGA_PLUS",
    "1920x1200" : "WUXGA",
    "768x480" : "WVGA",
    "1366x768" : "WXGA",
    "1440x900" : "WXGA_PLUS",
    "1024x768" : "XGA",
    "1152x864" : "XGA_PLUS"
 }
 export const screenResolution = {
    "A": "2880x1800",
    "B": "3200x2000",
    "C": "3072x1920",
    "D": "3840x2160",
    "E": "5120x2880",
    "F": "7680x4320",
    "G": "2048x1080",
    "H": "4096x2160",
    "I": "960x640",
    "J": "1920x1080",
    "K": "854x480",
    "L": "1280x720",
    "M": "240x160",
    "N": "5120x4096",
    "O": "6400x4800",
    "P": "480x320",
    "Q": "4096x3072",
    "R": "640x360",
    "S": "960x540",
    "T": "3200x1800",
    "U": "160x120",
    "V": "2560x2048",
    "W": "3200x2400",
    "X": "320x240",
    "Y": "2048x1152",
    "Z": "2048x1536",
    "a": "800x600",
    "b": "1280x1024",
    "c": "1400x1050",
    "d": "3440x1440",
    "e": "1600x1200",
    "f": "640x480",
    "g": "6400x4896",
    "h": "7680x4800",
    "i": "5120x3200",
    "j": "2560x1440",
    "k": "3840x2400",
    "l": "400x240",
    "m": "2560x1600",
    "n": "1024x576",
    "o": "1024x600",
    "p": "1680x1050",
    "q": "1920x1200",
    "r": "768x480",
    "s": "1366x768",
    "t": "1440x900",
    "u": "1024x768",
    "v": "1152x864"
};

export const oldToNew = {
    '1': 'A',
    '2': 'B',
    '3': 'C',
    '4': 'D',
    '5': 'E',
    '6': 'F',
    '7': 'G',
    '8': 'H',
    '9': 'I',
    '10': 'J',
    '11': 'K',
    '12': 'L',
    '13': 'M',
    '14': 'N',
    '15': 'O',
    '16': 'P',
    '17': 'Q',
    '18': 'R',
    '19': 'S',
    '20': 'T',
    '21': 'U',
    '22': 'V',
    '23': 'W',
    '24': 'X',
    '25': 'Y',
    '26': 'Z',
    '27': 'a',
    '28': 'b',
    '29': 'c',
    '30': 'd',
    '31': 'e',
    '32': 'f',
    '33': 'g',
    '34': 'h',
    '35': 'i',
    '36': 'j',
    '37': 'k',
    '38': 'l',
    '39': 'm',
    '40': 'n',
    '41': 'o',
    '42': 'p',
    '43': 'q',
    '44': 'r',
    '45': 's',
    '46': 't',
    '47': 'u',
    '48': 'v',
    '49': 'w',
    '50': 'x',
    '51': 'y',
    '52': 'z'
}
 export const procDisplay = {
    1 : '225',
    2 : '225F',
    3 : '225H',
    4 : '225T',
    5 : '225U',
    6 : '235',
    7 : '235H',
    8 : '235HX',
    9 : '235T',
    10 : '235U',
    11 : '245',
    12 : '245HX',
    13 : '245T',
    14: '255H',
    15: '255HX',
    16 : '255U',
    17 : '265',
    18 : '265F',
    19 : '265H',
    20 : '265HX',
    21 : '265T',
    22 : '265U',
    23 : '275HX',
    24 : '285',
    25 : '285H',
    26 : '285HX',
    27 : '285T',
    28 : '245K',
    29 : '245KF',
    30 : '265K',
    31 : '265KF',
    32 : '285K',
    33 : '226V',
    34 : '228V',
    35 : '236V',
    36 : '238V',
    37 : '256V',
    38 : '258V',
    39 : '266V',
    40 : '268V',
    41 : '288V',
    42 : '105UL',
    43 : '125HL',
    44 : '125UL',
    45 : '135HL',
    46 : '135UL',
    47 : '155HL',
    48 : '155UL',
    49 : '165HL',
    50 : '165UL',
    51 : '125H',
    52 : '125U',
    53 : '134U',
    54 : '135H',
    55 : '135U',
    56 : '155H',
    57 : '155U',
    58 : '164U',
    59 : '165H',
    60 : '165U',
    61 : '185H'
 }